import { render } from "./BrandName.vue?vue&type=template&id=041e1bf2"
import script from "./BrandName.vue?vue&type=script&lang=js"
export * from "./BrandName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__